import { slider } from "./modules/slider";
import { scrollTop } from "./modules/scrollTop";

window.addEventListener("DOMContentLoaded", () => {
  slider();
  scrollTop();
});
